import { HEADER_CLICK_IDS } from '../../types';
import { useTranslation } from 'next-i18next';
import { Link } from '@dx-ui/global-ui-prism';
import { dispatchGlobalNavigationClick, sendInteractionReward } from '../../header.utilities';
import { sendReward } from '@dx-ui/framework-conductrics';
import { LoginForm } from '@dx-ui/osc-login';
import { JoinModal } from '@dx-ui/osc-join-modal-button';
import Icon from '@dx-ui/osc-icon';
import { useHeaderContext } from '../../context/header-context';
import { useHeaderStateContext } from '../../context/header-state-context';
import { NavItemWithModal } from '../../brand-header-body/nav-items';

export const MobileAuthCluster = () => {
  const [t] = useTranslation(['osc-header', 'osc-login']);
  const {
    user: { user, loginOptions, onSignInAttempt, analytics },
    features: { shouldSuppressJoinAndSignIn, shouldOpenJoinInPage, shouldOpenJoinInNewWindow },
    navigation: {
      languageSelectorOptions,
      onGlobalNavigationClick,
      isLegacyGlobalNavigationClickAnalyticsEnabled = true,
    },
  } = useHeaderContext();

  const {
    refs: { userLoggedInButtonRef },
    handlers: { accountPressed },
    menuState: { isAccountOpen, setIsAccountOpen, setIsMenuOpen },
    activeUserLinks: links,
  } = useHeaderStateContext();

  const joinButtonClasses =
    'm-auto inline-block border-e border-surface pe-2 text--sm font-semibold brand-ey:font-normal brand-wa:font-normal';

  const hasLoginLinks = (links?.signInLink || links?.signUpLink) && !shouldSuppressJoinAndSignIn;
  if (!user && !hasLoginLinks) return null;

  return user ? (
    <button
      className="items-center"
      onClick={() => {
        dispatchGlobalNavigationClick(
          HEADER_CLICK_IDS.MemberName,
          onGlobalNavigationClick,
          isLegacyGlobalNavigationClickAnalyticsEnabled
        );
        accountPressed();
      }}
      aria-expanded={isAccountOpen}
      type="button"
    >
      <Icon name="user-circle" size="md" className="m-auto block" />
      <span className="text--sm break-all font-semibold brand-ey:font-normal brand-wa:font-normal">
        {t('greetings', { username: user.name })}
      </span>
    </button>
  ) : (
    <div className="flex flex-col pt-7">
      <div className="flex items-center">
        {links?.signUpLink ? (
          shouldOpenJoinInPage ? (
            <div className="h-fit">
              <Link
                {...links.signUpLink}
                showNewWindowIcon={false}
                isNewWindow={shouldOpenJoinInNewWindow}
                underline={false}
                className={joinButtonClasses}
                onClick={() => {
                  sendInteractionReward();
                  sendReward('nav-join-click');
                  dispatchGlobalNavigationClick(
                    HEADER_CLICK_IDS.Join,
                    onGlobalNavigationClick,
                    isLegacyGlobalNavigationClickAnalyticsEnabled
                  );
                }}
              >
                {t('osc-header:signUp')}
              </Link>
            </div>
          ) : (
            <div className="h-fit">
              <JoinModal
                analytics={analytics}
                language={languageSelectorOptions?.locale || 'en'}
                onLoginAttempt={onSignInAttempt}
                dialogTrigger={
                  <button
                    type="button"
                    className={joinButtonClasses}
                    onClick={() => {
                      sendInteractionReward();
                      sendReward('nav-join-click');
                      dispatchGlobalNavigationClick(
                        HEADER_CLICK_IDS.Join,
                        onGlobalNavigationClick,
                        isLegacyGlobalNavigationClickAnalyticsEnabled
                      );
                    }}
                  >
                    {t('osc-header:signUp')}
                  </button>
                }
                onSuccessfulLogin={() => {
                  setTimeout(() => userLoggedInButtonRef.current?.focus(), 1000);
                }}
              />
            </div>
          )
        ) : null}

        {links.signInLink ? (
          <div
            className="ps-2"
            onClick={() => {
              sendInteractionReward();
              dispatchGlobalNavigationClick(
                HEADER_CLICK_IDS.SignIn,
                onGlobalNavigationClick,
                isLegacyGlobalNavigationClickAnalyticsEnabled
              );
              setIsAccountOpen(false);
              setIsMenuOpen(false);
            }}
          >
            <Icon name="user-circle" size="md" className="-ms-[22px] -mt-7 block" />
            <NavItemWithModal
              onLoginAttempt={onSignInAttempt}
              analytics={analytics}
              section="user"
              loggedInButtonRef={userLoggedInButtonRef}
              shouldOpenJoinInPage={shouldOpenJoinInPage}
              locale={languageSelectorOptions?.locale || 'en'}
              dialogTrigger={
                <button
                  type="button"
                  className="text--sm font-semibold brand-ey:font-normal brand-wa:!font-normal"
                >
                  {t('osc-login:signIn')}
                </button>
              }
            >
              <LoginForm
                onLoginAttempt={onSignInAttempt}
                {...loginOptions}
                sourceId="OHW"
                isInModal={true}
              />
            </NavItemWithModal>
          </div>
        ) : null}
      </div>
    </div>
  );
};
